import { ALLOWED_FILE_EXTENSIONS, MAX_FILE_SIZE_ALLOWED } from "Views/UploadInvoice/const";

export const validateFile = (file: File) => {
  const fileExtension = file.name.split(".").pop().toLowerCase();
  const extensionValid = ALLOWED_FILE_EXTENSIONS.includes(fileExtension);
  const sizeValid = file.size <= MAX_FILE_SIZE_ALLOWED;
  const isFileValid = extensionValid && sizeValid;
  return { isFileValid, sizeValid, extensionValid };
};
